module.exports = __webpack_public_path__ + "static/media/incentives-screenshot.bf598d0b.png";